export default "__VITE_ASSET__CbrfFQSX__"